export const isDirectBundlePreview = () => window.location.host.match(/static/);

export function getRandomInt(max: number) {
  return Math.floor(Math.random() * max);
}
